import type { DirectoryFilters } from "../types";

/**
 * Query-key factory for the expert slice. Each list exposes a stable root so a
 * mutation (favorite add/remove) can invalidate the whole subtree after a
 * write. The directory key carries the action + filters so a different action
 * or filter set is cached separately.
 */
export const expertKeys = {
  all: ["experts"] as const,
  serviceRegions: () => [...expertKeys.all, "service-regions"] as const,
  directory: (action: string | null, filters?: DirectoryFilters) =>
    [...expertKeys.all, "directory", action ?? "none", filters ?? {}] as const,
  directorySectors: () => [...expertKeys.all, "directory-sectors"] as const,
  profile: (id: string, action?: string | null) =>
    [...expertKeys.all, "profile", id, action ?? "none"] as const,
  favorites: (action?: string | null) =>
    [...expertKeys.all, "favorites", action ?? "all"] as const,
  dashboard: () => [...expertKeys.all, "dashboard"] as const,
  mandates: () => [...expertKeys.all, "mandates"] as const,
  invitations: () => [...expertKeys.all, "invitations"] as const,
  // Registration wizard (the caller's own resumable draft).
  registration: () => [...expertKeys.all, "registration"] as const,
  registrationExpertise: () =>
    [...expertKeys.all, "registration", "expertise"] as const,
  registrationGoals: () => [...expertKeys.all, "registration", "goals"] as const,
  catalogue: () => [...expertKeys.all, "registration", "catalogue"] as const,
  invitationValidate: (token: string) =>
    [...expertKeys.all, "invitation-validate", token] as const,
  // CQDD admin back-office.
  admin: () => [...expertKeys.all, "admin"] as const,
  adminList: (params?: Record<string, unknown>) =>
    [...expertKeys.admin(), "list", params ?? {}] as const,
  adminDetail: (id: string) => [...expertKeys.admin(), "detail", id] as const,
  adminInvitations: (params?: Record<string, unknown>) =>
    [...expertKeys.admin(), "invitations", params ?? {}] as const,
  adminCounts: () => [...expertKeys.admin(), "counts"] as const,
} as const;
